import { styled, css } from '@mui/material/styles';
import ListMUI from '@mui/material/List';
import ListItemMUI from '@mui/material/ListItem';
import { Typography, Stack, StackProps } from '@mui/material';

interface QuickMessagesContainerProps extends StackProps {
  isTabsMode?: boolean;
}

export const QuickMessagesContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isTabsMode',
})<QuickMessagesContainerProps>(
  ({ theme, isTabsMode }) => css`
    background: ${theme.palette.common.white};
    border-top: ${isTabsMode ? 'none' : `solid 1px ${theme.palette.neutral.var30}`};
    width: auto;

    ${theme.breakpoints.down('md')} {
      order: 1;
    }
  `
);

export const List = styled(ListMUI)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    overflow-y: auto;
    max-height: 30rem;
    padding: 0 0.8rem 0.8rem;
    cursor: pointer;
  `
);

export const ListItem = styled(ListItemMUI)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.6rem;
    padding-right: 0.4rem;
    gap: 0.8rem;
    border-radius: 0.4rem;
    background: ${theme.palette.neutral.var10};
    color: ${theme.palette.text.secondary};

    :focus,
    :hover {
      background: ${theme.palette.neutral.var20};
      outline: none;
      color: ${theme.palette.text.primary};
    }
  `
);

export const ListItemBody = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    color: ${theme.palette.text.primary};
  `
);

export const ListItemHeader = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex-wrap: wrap;
  `
);

export const ListItemAdd = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.8rem;
    color: inherit;
  `
);

export const ShortcutMessage = styled(Typography)`
  color: ${({ theme }) => theme.palette.neutral.var70};
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  width: 100%;
`;
